var _circle, _mask, _path, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4999,
    cy: 9.64673,
    r: 3.61957,
    fill: "#F17E5B",
    stroke: "#F17E5B",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_171_310",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89111 21.7983C5.00374 17.6194 8.4267 14.2663 12.6328 14.2663C16.91 14.2663 20.3773 17.7336 20.3774 22.0107C18.2699 23.6298 15.6317 24.5924 12.7687 24.5924C9.78255 24.5924 7.04099 23.5453 4.89111 21.7983Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89111 21.7983C5.00374 17.6194 8.4267 14.2663 12.6328 14.2663C16.91 14.2663 20.3773 17.7336 20.3774 22.0107C18.2699 23.6298 15.6317 24.5924 12.7687 24.5924C9.78255 24.5924 7.04099 23.5453 4.89111 21.7983Z",
    fill: "#F17E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89111 21.7983L2.89184 21.7444L2.8653 22.7291L3.62981 23.3504L4.89111 21.7983ZM20.3774 22.0107L21.5959 23.5967L22.3774 22.9962L22.3774 22.0107L20.3774 22.0107ZM6.89039 21.8522C6.9739 18.7535 9.51323 16.2663 12.6328 16.2663V12.2663C7.34018 12.2663 3.03358 16.4852 2.89184 21.7444L6.89039 21.8522ZM12.6328 16.2663C15.8054 16.2663 18.3773 18.8382 18.3774 22.0108L22.3774 22.0107C22.3773 16.629 18.0145 12.2663 12.6328 12.2663V16.2663ZM19.1589 20.4247C17.3886 21.7848 15.1758 22.5924 12.7687 22.5924V26.5924C16.0876 26.5924 19.1512 25.4749 21.5959 23.5967L19.1589 20.4247ZM12.7687 22.5924C10.2585 22.5924 7.9588 21.714 6.15241 20.2461L3.62981 23.3504C6.12317 25.3766 9.30664 26.5924 12.7687 26.5924V22.5924Z",
    fill: "#F17E5B",
    mask: "url(#path-2-inside-1_171_310)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    stroke: "#F17E5B",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8a83d6ae2283bc1018d9312d97fb6ee0.svg";
export { ForwardRef as ReactComponent };